<template>
    <div class="situationInfo">
        <el-menu :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            active-text-color='#1076ec'
            @select="handleSelect">
            <el-menu-item
              v-for="item in navlist"
              :key="item.index"
              :index='item.index'>
              {{item.title}}
            </el-menu-item>
        </el-menu>

        <div class="specific-info">
          <keep-alive>
            <!-- <router-view @updata="updataCode"></router-view> -->
            <router-view ></router-view>
          </keep-alive>
            <!-- <router-view ref="saveInfo" @updata="updataCode"></router-view> -->
        </div>

        <el-divider></el-divider>
        <div>
            <el-button class="btn-style" type="success" @click="pageSave('B')">保存</el-button>
            <el-button class="btn-style" type="info" @click="previews">预览</el-button>
            <el-button type="primary" v-if="gmtModify !== null " @click="isShow">{{isPublished === '0' ? '上线' : '下线' }}</el-button>
            <el-button class="btn-style" type="primary" v-if="gmtModify === null " @click="pageRelease('F')">发布</el-button>
        </div>

        <el-dialog
          title="园区详情预览"
          :visible.sync="centerDialogVisible"
          width="90%"
          center
          v-if="centerDialogVisible">

          <garden-detail-preview @cancelBound="centerDialogVisible=false"></garden-detail-preview>
        </el-dialog>
    </div>
</template>

<script>
import GardenDetailPreview from '../../garden/gardenDetailPreview.vue'
export default {
  neme: 'situationInfo',
  props: {

  },
  components: {
    GardenDetailPreview
  },
  data () {
    return {
      code: null,
      datailId: '',
      centerDialogVisible: false,
      activeIndex: '1',
      // 导航标签
      navlist: [
        {
          title: '概况信息',
          index: '1'
        },
        {
          title: '房源信息',
          index: '2'
        },
        {
          title: '招商信息',
          index: '3'
        },
        {
          title: '园区服务',
          index: '4'
        },
        {
          title: '周边配套',
          index: '5'
        },
        {
          title: '荣誉资质',
          index: '6'
        },
        {
          title: '数字园区',
          index: '7'
        }
      ],
      baseData: {}, // 基础信息
      gardenInfo: {}, // 详细信息
      status: '0', // 发布状态
      isPublished: '', // 显示隐藏【0隐，1显】
      gmtModify: '', // 是否发布 【null为未发布】
      form: {}
    }
  },
  // eslint-disable-next-line no-dupe-keys
  computed: {

  },
  created () {
    this.getGardenBaseInfo()

    // this.updataCode
  },
  mounted () {
    document.documentElement.scrollTop = 0
    // this.$parent.sureitem = '/situationInfo'
  },
  methods: {

    // 切换园区信息管理tab页
    handleSelect (key) {
      if (key === '1') { this.$router.push('/surveyInfo') }
      if (key === '2') { this.$router.push('/housingInfo') }
      if (key === '3') { this.$router.push('/investmentInfo') }
      if (key === '4') { this.$router.push('/gardenServe') }
      if (key === '5') { this.$router.push('/surroundingFacility') }
      if (key === '6') { this.$router.push('/honorAptitude') }
      if (key === '7') { this.$router.push('/figureGarden') }
      this.activeIndex = key
    },

    // 初始化园区状态
    async getGardenBaseInfo () {
      try {
        const res = await this.$get(this.$url.gardenInfoManage.gardenBaseInfo)

        const { code, msg, data } = res.data
        if (code === 200) {
          // this.$route.query.id = data.basic.id
          this.isPublished = data.extra.isPublished // 显示隐藏
          this.gmtModify = data.extra.gmtModify // 是否发布
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 预览
    previews () {
      // this.$refs.saveInfo.preview()
      this.$eventBus.$emit('surverSave') // $emit用来发送事件

      setTimeout(() => {
        this.centerDialogVisible = true
      }, 1000)
    },

    // 保存按钮
    pageSave (val) {
      this.$eventBus.$emit('surverSave') // $emit用来发送事件

      const survey = JSON.parse(sessionStorage.getItem('LsurveyInfo'))
      const housing = JSON.parse(sessionStorage.getItem('LhousingInfo'))
      const investment = JSON.parse(sessionStorage.getItem('LinvestmentInfo'))
      const gardenServe = JSON.parse(sessionStorage.getItem('LgardenServeInfo'))
      const surrounding = JSON.parse(sessionStorage.getItem('LsurroundingInfo'))
      const honor = JSON.parse(sessionStorage.getItem('LhonorInfo'))
      const figure = JSON.parse(sessionStorage.getItem('LfigureInfo'))

      this.form = Object.assign(survey, housing, investment, gardenServe, surrounding, honor, figure)

      setTimeout(() => {
        this.saves(val)
      }, 2000)
    },

    // 发布按钮
    pageRelease (val) {
      this.$eventBus.$emit('surverSave') // $emit用来发送事件

      const survey = JSON.parse(sessionStorage.getItem('LsurveyInfo'))
      const housing = JSON.parse(sessionStorage.getItem('LhousingInfo'))
      const investment = JSON.parse(sessionStorage.getItem('LinvestmentInfo'))
      const gardenServe = JSON.parse(sessionStorage.getItem('LgardenServeInfo'))
      const surrounding = JSON.parse(sessionStorage.getItem('LsurroundingInfo'))
      const honor = JSON.parse(sessionStorage.getItem('LhonorInfo'))
      const figure = JSON.parse(sessionStorage.getItem('LfigureInfo'))

      this.form = Object.assign(survey, housing, investment, gardenServe, surrounding, honor, figure)

      setTimeout(() => {
        this.isPublished = '1'
        this.saves(val)
      }, 2000)
    },

    // 是否展示在园区
    async isShow () {
      if (this.isPublished === '0') {
        this.isPublished = '1'
      } else {
        this.isPublished = '0'
      }

      const res = await this.$post(this.$url.gardenInfoManage.gardenUpLoadInfo, {
        isPublished: this.isPublished
      })
      const { code, msg } = res.data
      if (code === 200) {
        this.$message.success('操作成功！')
      } else {
        console.log(msg)
      }
    },

    // 请求接口保存数据
    async saves (val) {
      // console.log(this.form)
      const res = await this.$post(this.$url.gardenInfoManage.gardenUpLoadInfo, {
        // isPublished: this.$parent.status, // 发布状态

        // 概况信息
        // gmtModify: this.gmtModify, // 是否发布
        isPublished: this.isPublished, // 显示隐藏
        operationEntity: this.form.operationEntity ? this.form.operationEntity : '', // 运营主体
        logo: this.form.logo ? this.form.logo : '', // 园区logo
        basementScene: this.form.basementScene ? this.form.basementScene : '', // 园区风采
        phone: this.form.phone, // 联系电话

        glory: this.form.glory ? this.form.glory : '', // 荣誉称号
        district: this.form.district ? this.form.district : '',
        districtCode: this.form.districtCode ? this.form.districtCode : '', // 所属地区
        districtDetail: this.form.districtDetail ? this.form.districtDetail : '', // 详细地址
        url: this.form.url ? this.form.url : '', // 官网网址
        basementDetail: this.form.basementDetail ? this.form.basementDetail : '', // 园区简介
        startDate: this.form.startDate ? this.form.startDate : '0000-00-00 00:00:00', // 建园时间
        incubationArg01: this.form.incubationArg01 ? this.form.incubationArg01 : '', // 孵化面积
        incubationArg02: this.form.incubationArg02 ? this.form.incubationArg02 : '', // 在孵各类企业总数
        incubationArg03: this.form.incubationArg03 ? this.form.incubationArg03 : '', // 在孵留创企业数
        incubationArg04: this.form.incubationArg04 ? this.form.incubationArg04 : '', // 累计留创企业数
        incubationArg05: this.form.incubationArg05 ? this.form.incubationArg05 : '', // 高新技术留创企业数
        incubationArg06: this.form.incubationArg06 ? this.form.incubationArg06 : '', // 在孵留创企业注册资本
        incubationArg07: this.form.incubationArg07 ? this.form.incubationArg07 : '', // 留创企业上一年营业收入
        incubationArg08: this.form.incubationArg08 ? this.form.incubationArg08 : '', // 留创企业上一年税收贡献
        incubationArg09: this.form.incubationArg09 ? this.form.incubationArg09 : '', // 留创企业知识产权
        incubationArg10: this.form.incubationArg10 ? this.form.incubationArg10 : '', // 在园留学人数
        incubationArg11: this.form.incubationArg11 ? this.form.incubationArg11 : '', // 高层次留学人才数

        // 房源信息
        apartmentInfo: this.form.apartmentInfo ? this.form.apartmentInfo : '', // 房源信息简介
        apartmentConsultPhone: this.form.apartmentConsultPhone ? this.form.apartmentConsultPhone : '', // 看房电话
        priceRange: this.form.priceRange ? this.form.priceRange : '', // 出租房源信息

        // 招商信息
        investmentConsultPhone: this.form.investmentConsultPhone ? this.form.investmentConsultPhone : '', // 招商热线
        investmentPolicy: this.form.investmentPolicy ? this.form.investmentPolicy : '', // 招商政策

        // 园区服务
        serviceDescribe: this.form.serviceDescribe ? this.form.serviceDescribe : '', // 服务描述
        basicService: this.form.basicService ? this.form.basicService : '', // 基础服务
        companyService: this.form.companyService ? this.form.companyService : '', // 企业服务

        // 周边配套
        supportFacility: this.form.supportFacility ? this.form.supportFacility : '', // 配套简述
        location: this.form.location, // 位置确认

        // 荣誉资质
        honorIntroduction: this.form.honorIntroduction ? this.form.honorIntroduction : '', // 荣誉简述
        honorPicture: this.form.honorPicture ? this.form.honorPicture : '', // 荣誉资质图片

        // 数字园区
        website: this.form.website ? this.form.website : '', // 网站地址
        thumbnail: this.form.thumbnail ? this.form.thumbnail : '', // 缩略图
        video: this.form.video ? this.form.video : '' // 视频资料
      })

      const { code, msg } = res.data
		// return false;
      if (code === 200) {
        if (this.gmtModify === null && val === 'F') {
          this.$message.success('发布成功！')
        }
        if (val === 'B') {
          this.$message.success('保存成功！')
        }

        setTimeout(() => {
          location.reload()
        }, 2000)
      } else {
        // this.$message.error(msg)
        console.log(msg)
      }
    }

  }
}
</script>

<style scoped lang="less">
.situationInfo{
  font-size: 16px;

  .btn-style{
    margin: 0 20px;
  }
}
.specific-info{
    margin-top: 30px;

}
</style>
